import * as type from '../../../actions/index.types';

const initialState = {
    visitorsListLoading: false,
    visitorsListData: null,
    visitorsPagination: null,

    visitorDetailsLoading: false,
    visitorDetailsData: null,

    createVisitorLoading: false,
    updateVisitorLoading: false,
    deleteVisitorLoading: false,

    // Block and unblock share one flag: a visitor is only ever in one of the two
    // states, so no screen can have both actions in flight at once.
    blockLoading: false,

    // { total, blocked, active } derived from limit=1 probes — there is no
    // /api/visitors/stats endpoint.
    summaryLoading: false,
    summaryData: null,

    error: null,
};

export function VisitorReducer(state = initialState, action) {
    switch (action.type) {
        case type.SOCIETY_GET_VISITORS_LIST:
            return { ...state, visitorsListLoading: true, error: null };
        case type.SOCIETY_GET_VISITORS_LIST_SUCCESS: {
            const meta = action.payload?.pagination;
            const fallbackCount = action.payload?.count ?? action.payload?.total ?? 0;
            return {
                ...state,
                visitorsListLoading: false,
                visitorsListData: action.payload?.rows || action.payload?.data || action.payload || [],
                visitorsPagination: meta || { total: fallbackCount, totalPages: Math.ceil(fallbackCount / 10) },
                error: null,
            };
        }
        case type.SOCIETY_GET_VISITORS_LIST_FAILURE:
            return { ...state, visitorsListLoading: false, error: action?.message };

        case type.SOCIETY_GET_VISITOR_DETAILS:
            return { ...state, visitorDetailsLoading: true, error: null };
        case type.SOCIETY_GET_VISITOR_DETAILS_SUCCESS:
            return { ...state, visitorDetailsLoading: false, visitorDetailsData: action.payload, error: null };
        case type.SOCIETY_GET_VISITOR_DETAILS_FAILURE:
            return { ...state, visitorDetailsLoading: false, visitorDetailsData: null, error: action?.message };

        case type.SOCIETY_CREATE_VISITOR:
            return { ...state, createVisitorLoading: true, error: null };
        case type.SOCIETY_CREATE_VISITOR_SUCCESS:
            return { ...state, createVisitorLoading: false, error: null };
        case type.SOCIETY_CREATE_VISITOR_FAILURE:
            return { ...state, createVisitorLoading: false, error: action?.message };

        case type.SOCIETY_UPDATE_VISITOR:
            return { ...state, updateVisitorLoading: true, error: null };
        case type.SOCIETY_UPDATE_VISITOR_SUCCESS:
            return { ...state, updateVisitorLoading: false, error: null };
        case type.SOCIETY_UPDATE_VISITOR_FAILURE:
            return { ...state, updateVisitorLoading: false, error: action?.message };

        case type.SOCIETY_DELETE_VISITOR:
            return { ...state, deleteVisitorLoading: true, error: null };
        case type.SOCIETY_DELETE_VISITOR_SUCCESS:
            return { ...state, deleteVisitorLoading: false, error: null };
        case type.SOCIETY_DELETE_VISITOR_FAILURE:
            return { ...state, deleteVisitorLoading: false, error: action?.message };

        case type.SOCIETY_BLOCK_VISITOR:
        case type.SOCIETY_UNBLOCK_VISITOR:
            return { ...state, blockLoading: true, error: null };
        case type.SOCIETY_BLOCK_VISITOR_SUCCESS:
        case type.SOCIETY_UNBLOCK_VISITOR_SUCCESS:
            return { ...state, blockLoading: false, error: null };
        case type.SOCIETY_BLOCK_VISITOR_FAILURE:
        case type.SOCIETY_UNBLOCK_VISITOR_FAILURE:
            return { ...state, blockLoading: false, error: action?.message };

        case type.SOCIETY_GET_VISITOR_SUMMARY:
            return { ...state, summaryLoading: true };
        case type.SOCIETY_GET_VISITOR_SUMMARY_SUCCESS:
            return { ...state, summaryLoading: false, summaryData: action.payload };
        case type.SOCIETY_GET_VISITOR_SUMMARY_FAILURE:
            // Counters are decoration; a failure leaves the last good numbers on
            // screen rather than blanking the banner.
            return { ...state, summaryLoading: false };

        default:
            return state;
    }
}
